import SezioniServiziContainer from './SezioniServiziContainer';

export default SezioniServiziContainer;
